import {
  getColorByBgColor,
  getHEXCodeFromString
} from "main/src/modules/common/utils";
import type { FC } from "react";
import { CustomLabel } from "../CustomLabel";
import { STANDARD_TAG_COLORS } from "@certa/catalyst/components/Tag/standardTagColors";
import { isStandardTagColor } from "./WorkflowStatusNew";

type WorkflowStatusPropsOld = {
  label?: string | number;
  customColorCode?: string | null;
  ellipsis?: string | number;
  onClick?: () => void;
};

/**
 * This component is deprecated and should not be used.
 * @example
 * // Preferred Usage
 * WorkflowStatusNew
 */
type WorkflowLabelTypes = "teal";

type Config = {
  backgroundColor: string;
  color: string;
};

const colorConfigs: Record<WorkflowLabelTypes, Config> = {
  teal: {
    backgroundColor: "var(--teal)",
    color: "neutral-0"
  }
};

export const WorkflowStatusOld: FC<WorkflowStatusPropsOld> = ({
  label,
  ellipsis,
  customColorCode,
  onClick
}) => {
  let config = colorConfigs["teal"];

  if (customColorCode) {
    let hexCode = null;
    if (isStandardTagColor(customColorCode))
      hexCode = STANDARD_TAG_COLORS[customColorCode].bgHexcode;
    else
      hexCode = getHEXCodeFromString(customColorCode, config.backgroundColor);

    config = {
      backgroundColor: hexCode,
      color: getColorByBgColor(hexCode, config.color)
    };
  }

  return (
    <CustomLabel
      onClick={onClick}
      ellipsis={ellipsis === undefined ? "190px" : ellipsis}
      label={label || ""}
      backgroundColor={config.backgroundColor}
      color={config.color}
    />
  );
};
